import BASEURLGESTTOR from '../api/gesttor'
import { cadastrarSuportePayload, paramsListaSuporte,  paramsListaSuporteOrganizacoes, comentarSuportePayload, atualizarSuportePayload } from '../../interfaces/suporte'


export function novoSuporte (payload: cadastrarSuportePayload) {
    return BASEURLGESTTOR.post('/suporte', payload)
}

export function listarSuporte (params: paramsListaSuporte) {
    return BASEURLGESTTOR.get (`/suporte?tipo=${params.tipo}&pagina=${params.pagina}&termo=${params.termo}&status=${params.status}`)
}

export function listarSuporteOrganizacoes (params: paramsListaSuporteOrganizacoes) {
    return BASEURLGESTTOR.get (`/organizacao/suporte?tipo=${params.tipo}&pagina=${params.pagina}&termo=${params.termo}&status=${params.status}&nomeFantasia=${params.nomeFantasia ?? ""}&idResponsavel=${params.idResponsavel ?? ""}&solicitanteTermo=${params.solicitanteTermo ?? ""}`)
}

export function comentarSuporte (idSuporte: string, payload: comentarSuportePayload) {
    return BASEURLGESTTOR.post(`/suporte/comentarios?idSuporte=${idSuporte}`, payload)
}

export function listarComentariosSuporte (idSuporte: string) {
    return BASEURLGESTTOR.get(`/suporte/comentarios?idSuporte=${idSuporte}`)
}

export function atualizarSuporte (idSuporte: string, payload: atualizarSuportePayload) {
    return BASEURLGESTTOR.patch(`/suporte?idSuporte=${idSuporte}`, payload)
}



